import MediaInput from 'src/Components/Form/MediaInput'
import Popup from 'src/Components/Popup'
import style from './style.module.scss'

interface Props {
  handleNewMedia: (e: React.FormEvent<HTMLFormElement>) => void,
  setNewMediaPopup: (value: boolean) => void,
  setFiles: (files: FileList | null) => void
}
export const MediaPopup = ({ handleNewMedia, setNewMediaPopup, setFiles }: Props) => {

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    setFiles(files);
  }
  return (
    <Popup className={style.new_media} title="Add new media" closePopup={() => setNewMediaPopup(false)}>
      <form onSubmit={handleNewMedia}>
        <MediaInput multiple={true} onChange={handleFileChange} />
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
